import React, {useEffect, useState, useRef} from 'react';
import { json, useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import ImageView from '../../../common/ImageView';
import AttachFiles from '../../../common/AttachFiles';
import '../css/DetailItems.css';
import ArrowDown from '../img/ep_arrow-down-bold.png';
import ArrowUp from '../img/ep_arrow-up-bold.png';
import Text from '../../../common/Text.js';
import parse from 'html-react-parser';


function DetailItems() {
    //메인,상세화면간 이동
    const location = useLocation();
    const title = location.state.title;
    var menukey = location.state.menukey;
    var cardkey = location.state?.cardkey;
                                                
    const [detailItem, SetDetailItem] = useState([]);
    const [fileItem, SetFileItem] = useState([]);
    const preCardKeyRef = useRef();

    useEffect( ()  => {
        console.log('처음 여기를 지나');
        console.log(menukey);
        console.log(preCardKeyRef);
        console.log(cardkey);
        if (preCardKeyRef.current !== cardkey) {
            console.log('여기를 와야되고');
            getDetailData();
            console.log(detailItem.Noti_title);
            //getFilelData();
        }
        preCardKeyRef.current = cardkey;
        window.scrollTo(0,0);

        console.log('fileItem.fileId');
        console.log(fileItem.fileId);

    }, [cardkey]);

    useEffect(() => {
        // alert("연결!!!!!");
        // console.log(JSON.stringify(currentNotice)+" D");
        const currentList =
         detailItem.length > 0 &&
        detailItem.find((notice) => notice.MatchType === "Current");
        // console.log(JSON.stringify(currentList)+" CC");
        // console.log(currentList.Uploadid+" C");
        getFilelData(currentList.Uploadid);
        console.log(detailItem.Noti_title);
        console.log(currentList.Noti_title);
        console.log('연결');
        // console.log(JSON.stringify(fileItem) +" Test");
        // console.log(fileItem.length>0 +" Test1");
        // console.log(fileItem.Fileid +" Test2");

      }, [detailItem]);

    //데이터 가져오기
    const getDetailData = async () => {
        console.log(menukey);
        console.log('menukey');
        if(menukey == 0) //채용공고
        axios.get('/api/RecruitDetailSelect',{params:{id:cardkey}})
        .then(response => {SetDetailItem(response.data);})
        .catch(error => console.log(error));
        else if(menukey == 1) //보도자료
        axios.get('/api/NewsDetailSelect',{params:{id:cardkey}})
        .then(response => {SetDetailItem(response.data);})
        .catch(error => console.log(error));
        else if(menukey == 2)  //포토갤러리
        axios.get('/api/GalleryDetailSelect',{params:{id:cardkey}})
        .then(response => {SetDetailItem(response.data);})
        .catch(error => console.log(error)); 
        else if(menukey == 3) //메거진
        axios.get('/api/MagzDetailSelect',{params:{id:cardkey}})
        .then(response => {SetDetailItem(response.data);})
        .catch(error => console.log(error));
        }

     //파일 가져오기
     const getFilelData = async (currentUploadId) => {
        // console.log(currentUploadId +"A");
        // if (currentUploadId > 0) await
         axios.get('/api/FileListSelect',{params:{uploadkey:currentUploadId}})
        .then(response => {SetFileItem(response.data);
            console.log(JSON.stringify(response.data) + "FileListSelect");
        })
        .catch(error => console.log(error));
    }
   
    //이전글, 현재글, 다음글 나누기
    const currentNotice = detailItem.length > 0 && detailItem.find(notice => notice.MatchType === 'Current'); //object
    const previousNotice = detailItem.length > 0 && detailItem.find(notice => notice.MatchType === 'Previous');
    const nextNotice = detailItem.length > 0 && detailItem.find(notice => notice.MatchType === 'Next');

    const htmlString = currentNotice?.Noti_contents;
    const content = typeof htmlString === 'string' ? parse(htmlString) : '';

    ////Navigate 
    const navigate = useNavigate();
    //목록으로 클릭이벤트
    const tolistBtnClick = (menukey) => {
        if(menukey == 0) //채용공고
            navigate('/RecruitmentCard');
        else if(menukey == 1) //보도자료
            navigate('/News');
        else if(menukey == 2)  //포토갤러리
            navigate('/Gallery');
            else if(menukey == 3) //메거진
                navigate('/CompanyMagazine');
    };

    const handleCardClick = (seq) => {


     if(menukey == 1) //보도자료
     {
        navigate('/DetailItems', {
            state: {
                title: '보도자료',
                menukey: 1,
                cardkey: seq
            },
        });}
        else if(menukey == 3) //메거진
        {
            navigate('/DetailItems', {
                state: {
                    title: '보도자료',
                    menukey: 3,
                    cardkey: seq
                },
            });}



     };
     const handleLinkClick = (url) => {
        window.open(url)
     };
 

    //이전글,다음글 클릭이벤트
    const toDetailBtnClick = (menukey, list) => {
        const titles = ['채용공고', '보도자료', '포토갤러리'];
        const title = titles[menukey];

        console.log('menukey');
        console.log(menukey);
        if(menukey == 1 || menukey == 3){ // 보도자료

            // url주소가 있으면 링크 / 없으면 상세화면

            console.log('list.Noti_url');
            console.log(list.Noti_url);
            console.log('list.Uploadid');
            console.log(list.Uploadid);

       
       

               /*
                1. 첨부가 있을경우 무조건 => 카드
                2. 첨부가 있고 링크가 있을경우 => 카드 
                3. 첨부도 없고 링크도 없을경우 => 카드
                4. 첨부가 없고 링크가 있는경우 => 링크
            */

  // // 첨부가 없고 링크가 있는경우 => 링크
  if((list.Uploadid == null || list.Uploadid == undefined || list.Uploadid == ''|| list.Uploadid == 'null' || list.Uploadid == "null" ||!(list.Uploadid)) &&
  (list.Noti_url != null && list.Noti_url !== undefined && list.Noti_url !== ''))
  {  
      console.log(list.Noti_url + 'url');
      handleLinkClick(list.Noti_url);
  }
  else
  {
      console.log(list.Gbn + 'Gbn');
      handleCardClick(list.Gbn); 
  }


           
        }
        else{

            console.log('menukey가 없어서 else로 넘어옴');
            
            navigate('/DetailItems', {
                state: {   
                    title,
                    menukey,
                    cardkey: list.seq
                },});
        }
       
    };


    return (
        <div >
            <div className='rootParents'>
                <div className='root-main'>
                    <div className='detail-container'>
                        <div className='detail-header'>
                            
                            <div className='detail-title'>{title}</div>
                            <div className='detail-title-line'></div>
                        </div>
                        <div className='detail-content-container'>
                            <div className='title-container'>
                                <div  style={{display : 'flex', flexDirection:'row', alignItems:'flex-end',justifyContent:'space-between'}}>
                                    <div className='title'>{currentNotice.Noti_title}</div>
                                    <div className='date'>{currentNotice.Noti_dt}</div>
                                </div>
                                    <div className='title-line'></div>
                            </div>
                            <div  style={{display : 'flex',flexDirection:'column' , margin: '20px 0 0 0'}}>
                                {/* 첨부파일 */}
                                <div  className='FileItemList'>
                                 <Text variant='px16w400B'>첨부파일 : </Text>
                                 { <AttachFiles uploadId={currentNotice.Uploadid} />}
                                   {/* { menukey !== 1 && <Text variant='px16w400B'>첨부파일 : </Text>}
                                    { menukey !== 1 && <AttachFiles uploadId={currentNotice.Uploadid} />}{/* 첨부파일은 보도자료는 제외*/}
                                </div>
                                <br/>
                                {/* 이미지뷰 */}
                                <div  style={{display : 'flex',flexDirection:'column',alignItems:'center'}}> 
                                {fileItem.map((fileList,index)=>{
                                    return <div>
                                    {fileItem.length > 0 && <ImageView fileId={fileList.Fileid} imageStyle={{  height: 'auto', display: 'block' }}/> }{/* 이미지 뷰는 공통적으로 들어감 */}
                                    </div>
                                 })}
                                 </div>
                                <br/>
                                {/* 내용*/}
                                <div  style={{display : 'flex', marginTop:'30px'}}>
                                {menukey !== 0 &&<Text variant='px20w400' className={"contents"}>{content}</Text>}
                                </div>
                                <br/>
                                <br/>
                                {/* URL*/}
                                { menukey === 1 && <Text variant='px20wB_det'> 
                                                    <div style={{marginBottom : '50px', marginTop : '20px'}}>
                                                    <Text variant="px20w400G" className={"UrlM"} >출처 : {currentNotice.Noti_mc}</Text>
                                                    <a className="Url" href={currentNotice.Noti_url}> 
                                                     {currentNotice.Noti_url}
                                                    </a>
                                                    </div>
                                                    </Text> }
                            </div>
                        </div>
                        <div className='boardList-container'>
                            {previousNotice ? (
                                <div className='boardList-prev'>
                                    <img src={ArrowUp} className='arrowUP'  ></img>
                                    <div className='preContent' onClick={() => toDetailBtnClick(menukey, previousNotice)} >{previousNotice.Noti_title}</div>
                                    <div className='preDate'>{previousNotice.Noti_dt}</div>
                                </div>
                            ) : (<div></div>) }
                        <div className='title-line' ></div>
                            {nextNotice ? (
                                <div className='boardList-next'>
                                    <img src={ArrowDown} className='arrowDOWN'  ></img>
                                    <div className='nextContent' onClick={() => toDetailBtnClick(menukey, nextNotice)}>{nextNotice.Noti_title}</div>
                                    <div className='nextDate'>{nextNotice.Noti_dt}</div>
                                </div>
                            ) : (<div></div>) }

                            <button className='to-list-btn' style={{borderRadius : '15px', margin: '10px 0 100px 0'}} onClick={() => tolistBtnClick(menukey)}>목록으로</button>

                        </div>
                        
                    </div>

                </div>
            </div>
        </div>
);
}

export default DetailItems;
